export const itemLabels: { [key: string]: string } = {
  Brand: "brand",
  Category: "category",
  Container: "container",
  Count: "count",
  "MG4 Portfolio Group": "mg4PortfolioGroup",
  "Planning Item": "planningItem",
  PPG: "ppg",
  "Product Group": "productGroup",
  "Product Line": "productLine",
  Size: "size",
  "Sub Brand": "subBrand",
  // LATAM
  Flavour: "flavourNames",
  // PFNA
  "Each UPC": "eachUPC",
};

export const customerLabels: { [key: string]: string } = {
  "Business Unit": "businessUnit",
  "CGI Trade Segment": "cg1TrageSegment",
  "Customer Group": "customerGroup",
  Region: "customerRegion",
  Sector: "customerSector",
  Global: "global",
  "IBP Demand Group": "ibpDemandGroup",
  "Key Account": "keyAccount",
  "Market Unit": "marketUnit",
  // LATAM
  Channel: "channels",
  "Demand Group (Chain)": "demandGroups",
  "Sub-Channel (Group)": "subChannels",
  "Regional Cluster": "regionalClusters",
  "Alternate IBP Demand Group": "alternateIBPDemandGroup",
};

export const salesGeoLables: { [key: string]: string } = {
  Sector: "salesSector",
  Country: "salesCountry",
  "Sales Region": "salesRegion",
  "Sales Business Org": "businessOrg",
  "Sales Division": "division",
  // PFNA
  "Sales Zone": "zone",
  Location: "location",
};

export const pfeLables: { [key: string]: string } = {
  Segment: "segment",
  "AC1/AC2": "ac1ac2",
};

export const locationLabels: { [key: string]: string } = {
  Global: "globalCode",
  // 'Sector':'sector',
  Sector: "locationSector",
  Country: "locationCountry",
  Region: "regionCode",
  "Planning Location": "planningLocationId",
};
